import { APP_PERMISSIONS } from '@exam-management/permissions';
import { useQBankStructure } from '@exam-management/qbs-provider';
import {
  QContentCreateFormProvider,
  QContentCreateSingleHeader,
} from '@exam-management/qcontent-creation';
import { Flex } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';
import { useMemo } from 'react';
import { Outlet } from 'react-router-dom';

export default function QContentCreateLayout() {
  const { qBankStructureLevels } = useQBankStructure();

  const qBankStructureLevelWithoutFirstLevel = useMemo(
    () => qBankStructureLevels.filter((qBankStructureLevel) => qBankStructureLevel.level !== 1),
    [qBankStructureLevels],
  );

  return (
    <PermissionGuard requiredPermission={[APP_PERMISSIONS.QBANK.QUESTION.CREATE]}>
      <QContentCreateFormProvider qbsLevels={qBankStructureLevelWithoutFirstLevel}>
        <Flex sx={{ flexDirection: 'column', width: 1, bgcolor: 'grey.50', height: '100dvh' }}>
          <QContentCreateSingleHeader />

          <Outlet />
        </Flex>
      </QContentCreateFormProvider>
    </PermissionGuard>
  );
}
